import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core";



const DeleteIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 1500 1500">
                <g>
                    <path fill="#3D4A78;" d="M958.658,543.453c-19.402,0-35.129,15.727-35.129,35.129v663.934
		c0,19.391,15.727,35.129,35.129,35.129c19.405,0,35.129-15.738,35.129-35.129V578.582
		C993.787,559.18,978.063,543.453,958.658,543.453L958.658,543.453z M958.658,543.453"/>
                    <g>
                        <defs>
                            <rect id="SVGID_1_" x="138.759" width="1222.482" height="1500"/>
                        </defs>
                        <clipPath id="SVGID_2_">
                        </clipPath>
                        <path fill="clip-path:url(#SVGID_2_);fill:#3D4A78;" d="M544.138,543.453c-19.402,0-35.129,15.727-35.129,35.129v663.934
			c0,19.391,15.727,35.129,35.129,35.129c19.405,0,35.129-15.738,35.129-35.129V578.582
			C579.267,559.18,563.543,543.453,544.138,543.453L544.138,543.453z M544.138,543.453"/>
                        <path fill="clip-path:url(#SVGID_2_);fill:#3D4A78;" d="M242.03,446.561v865.5c0,51.155,18.759,99.197,51.527,133.669
			c32.621,34.567,78.01,54.19,125.519,54.271h664.647c47.519-0.081,92.912-19.704,125.515-54.271
			c32.772-34.472,51.527-82.514,51.527-133.669v-865.5c65.139-17.29,107.35-80.22,98.638-147.06
			c-8.729-66.829-65.663-116.817-133.064-116.831H1046.48v-43.911c0.207-36.927-14.392-72.383-40.535-98.47
			C979.806,14.217,944.294-0.302,907.366,0H595.433c-36.927-0.302-72.439,14.217-98.578,40.289
			c-26.143,26.087-40.742,61.542-40.539,98.47v43.911H276.46c-67.402,0.014-124.335,50.002-133.064,116.831
			C134.684,366.341,176.891,429.27,242.03,446.561L242.03,446.561z M1083.724,1429.742H419.076
			c-60.063,0-106.788-51.597-106.788-117.681V449.649h878.22v862.412C1190.508,1378.145,1143.787,1429.742,1083.724,1429.742
			L1083.724,1429.742z M526.574,138.759c-0.232-18.292,6.959-35.898,19.939-48.811c12.97-12.91,30.615-20.006,48.92-19.69h311.933
			c18.306-0.316,35.951,6.78,48.92,19.69c12.98,12.899,20.171,30.52,19.936,48.811v43.911H526.574V138.759z M276.46,252.927h949.879
			c34.922,0,63.232,28.31,63.232,63.232s-28.31,63.232-63.232,63.232H276.46c-34.921,0-63.232-28.31-63.232-63.232
			S241.539,252.927,276.46,252.927L276.46,252.927z M276.46,252.927"/>
                    </g>
                    <path fill="fill:#3D4A78;" d="M751.398,543.453c-19.402,0-35.129,15.727-35.129,35.129v663.934
		c0,19.391,15.727,35.129,35.129,35.129c19.405,0,35.129-15.738,35.129-35.129V578.582
		C786.527,559.18,770.803,543.453,751.398,543.453L751.398,543.453z M751.398,543.453"/>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default DeleteIcon;